import { render } from "./colorPicker.vue?vue&type=template&id=f2f3fc52&ts=true"
import script from "./colorPicker.vue?vue&type=script&lang=ts"
export * from "./colorPicker.vue?vue&type=script&lang=ts"

import "./colorPicker.vue?vue&type=style&index=0&id=f2f3fc52&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__